import { useState, useCallback } from "react";
import { currencies, convert } from "../api/mockData";
import { CurrencyRow } from "./CurrencyRow";

export function CurrencyTable() {
  const [baseCurrency, setBaseCurrency] = useState("USD");
  const [baseAmount, setBaseAmount] = useState("100");

  const handleFocus = useCallback((code: string) => {
    setBaseCurrency(code);
  }, []);

  const handleChange = useCallback(
    (code: string, value: string) => {
      setBaseCurrency(code);
      setBaseAmount(value);
    },
    []
  );

  const getDisplayValue = useCallback(
    (code: string): string => {
      if (code === baseCurrency) return baseAmount;
      const numericAmount = parseFloat(baseAmount);
      if (!baseAmount || isNaN(numericAmount) || numericAmount === 0) return "";
      const converted = convert(numericAmount, baseCurrency, code);
      // Smart formatting: show 2 decimals for most, 0 for large numbers
      if (converted >= 1000) return converted.toFixed(2);
      if (converted >= 1) return converted.toFixed(2);
      return converted.toFixed(4);
    },
    [baseCurrency, baseAmount]
  );

  return (
    <div className="w-full max-w-lg mx-auto">
      <div className="flex flex-col gap-3">
        {currencies.map((currency, i) => (
          <CurrencyRow
            key={currency.code}
            currency={currency}
            value={getDisplayValue(currency.code)}
            isBase={currency.code === baseCurrency}
            staggerIndex={i + 1}
            onFocus={handleFocus}
            onChange={handleChange}
          />
        ))}
      </div>

      {/* Rate info footer */}
      <div
        className="mt-6 text-center text-xs text-[var(--color-ink-light)] animate-fade-in-up stagger-6"
        style={{ fontFamily: "var(--font-mono)", fontWeight: 300 }}
      >
        <p className="mb-1">
          1 {baseCurrency} ={" "}
          {currencies
            .filter((c) => c.code !== baseCurrency)
            .map((c) => {
              const rate = convert(1, baseCurrency, c.code);
              return `${rate >= 1 ? rate.toFixed(2) : rate.toFixed(4)} ${c.code}`;
            })
            .join(" · ")}
        </p>
        <p className="text-[var(--color-ink-light)]/50 mt-2">
          Tap any row to set as base currency
        </p>
      </div>
    </div>
  );
}
